/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ReverseAccessEntry = {
  orgId: string;
  grantedBy: string;
  grantedAt: Date;
  active: boolean;
  activatedBy: string | null;
  activatedAt: Date | null;
};

/** @internal */
export const ReverseAccessEntry$inboundSchema: z.ZodType<
  ReverseAccessEntry,
  z.ZodTypeDef,
  unknown
> = z.object({
  org_id: z.string(),
  granted_by: z.string(),
  granted_at: z.string().datetime({ offset: true }).transform(v => new Date(v)),
  active: z.boolean(),
  activated_by: z.nullable(z.string()),
  activated_at: z.nullable(
    z.string().datetime({ offset: true }).transform(v => new Date(v)),
  ),
}).transform((v) => {
  return remap$(v, {
    "org_id": "orgId",
    "granted_by": "grantedBy",
    "granted_at": "grantedAt",
    "activated_by": "activatedBy",
    "activated_at": "activatedAt",
  });
});
/** @internal */
export type ReverseAccessEntry$Outbound = {
  org_id: string;
  granted_by: string;
  granted_at: string;
  active: boolean;
  activated_by: string | null;
  activated_at: string | null;
};

/** @internal */
export const ReverseAccessEntry$outboundSchema: z.ZodType<
  ReverseAccessEntry$Outbound,
  z.ZodTypeDef,
  ReverseAccessEntry
> = z.object({
  orgId: z.string(),
  grantedBy: z.string(),
  grantedAt: z.date().transform(v => v.toISOString()),
  active: z.boolean(),
  activatedBy: z.nullable(z.string()),
  activatedAt: z.nullable(z.date().transform(v => v.toISOString())),
}).transform((v) => {
  return remap$(v, {
    orgId: "org_id",
    grantedBy: "granted_by",
    grantedAt: "granted_at",
    activatedBy: "activated_by",
    activatedAt: "activated_at",
  });
});

export function reverseAccessEntryToJSON(
  reverseAccessEntry: ReverseAccessEntry,
): string {
  return JSON.stringify(
    ReverseAccessEntry$outboundSchema.parse(reverseAccessEntry),
  );
}
export function reverseAccessEntryFromJSON(
  jsonString: string,
): SafeParseResult<ReverseAccessEntry, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ReverseAccessEntry$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ReverseAccessEntry' from JSON`,
  );
}
